import { types } from 'mobx-state-tree';


const MONEY_SOURCES = {
    DEPOSIT: 'deposit',
    SAVINGS_ACCOUNTS: 'savings-accounts',
    GIFT: 'gift',
    PROPERTY_SALE: 'property-sale',
    INVESTMENT_ACCOUNTS: 'investment-accounts',
    TFSA: 'tfsa',
    RRSP: 'rrsp',
    OTHER: 'other',
};

const MoneySourceEnum = types.enumeration('MoneySource', Object.values(MONEY_SOURCES));

export {
    MoneySourceEnum,
};
export default MONEY_SOURCES;
